import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
    PackageSearch,
    Upload,
    Download,
    Users,
    Home,
    Boxes,
    History,
    MoreHorizontal
} from "lucide-react";

import api from "../services/api";


function Dashboard({ onLogout }) {
    const navigate = useNavigate();

    const storedUser = JSON.parse(
        localStorage.getItem("user")
    );

    const [user, setUser] = useState(storedUser);
    const [permissions, setPermissions] = useState([]);
    const [loadingAccess, setLoadingAccess] = useState(true);


    // ========================================
    // Load logged-in user + permissions
    // ========================================

    useEffect(() => {
        const loadAccess = async () => {
            try {
                const response =
                    await api.get("/auth/me");

                setUser(
                    response.data.user
                );

                setPermissions(
                    response.data.permissions || []
                );

            } catch (error) {
                console.error(
                    "Unable to load dashboard permissions",
                    error
                );

            } finally {
                setLoadingAccess(false);
            }
        };

        loadAccess();
    }, []);


    // ========================================
    // Permission helper
    // ========================================

    const hasPermission = (permissionKey) => {
        if (user?.role === "OWNER") {
            return true;
        }

        return permissions.some(
            permission =>
                permission.permission_key ===
                permissionKey
        );
    };


    const isOwner =
        user?.role === "OWNER";


    if (loadingAccess) {
        return (
            <div className="mobile-app">
                <div className="loading-state">
                    Loading dashboard...
                </div>
            </div>
        );
    }


    return (
        <div className="mobile-app">

            <header className="top-header">

                <div>
                    <p className="small-label">
                        Welcome
                    </p>

                    <h2>
                        {user?.full_name}
                    </h2>
                </div>


                <button
                    className="logout-button"
                    onClick={onLogout}
                >
                    Logout
                </button>

            </header>


            <main className="dashboard-content">

                <section className="welcome-card">

                    <p>
                        PriceManager
                    </p>

                    <h1>
                        Dashboard
                    </h1>

                    <span>
                        {user?.role}
                    </span>

                </section>


                <h3 className="section-title">
                    Quick Actions
                </h3>


                <div className="action-grid">

                    {/* PRODUCTS - visible to everyone */}

                    <button
                        className="action-card"
                        onClick={() =>
                            navigate("/products")
                        }
                    >
                        <span className="action-icon">
                            <PackageSearch
                                size={22}
                            />
                        </span>

                        <strong>
                            Products
                        </strong>

                        <small>
                            Search and manage prices
                        </small>
                    </button>


                    {/* IMPORT */}

                    {hasPermission(
                        "UPLOAD_EXCEL"
                    ) && (

                        <button
                            className="action-card"
                            onClick={() =>
                                navigate("/import")
                            }
                        >
                            <span className="action-icon">
                                <Upload
                                    size={22}
                                />
                            </span>

                            <strong>
                                Import
                            </strong>

                            <small>
                                Upload Excel price list
                            </small>
                        </button>

                    )}


                    {/* EXPORT */}

                    {hasPermission(
                        "EXPORT_FILES"
                    ) && (

                        <button
                            className="action-card"
                            onClick={() =>
                                navigate("/export")
                            }
                        >
                            <span className="action-icon">
                                <Download
                                    size={22}
                                />
                            </span>

                            <strong>
                                Export
                            </strong>

                            <small>
                                Excel or PDF
                            </small>
                        </button>

                    )}


                    {/* STAFF - OWNER ONLY */}

                    {isOwner && (

                        <button
                            className="action-card"
                            onClick={() =>
                                navigate("/staff")
                            }
                        >
                            <span className="action-icon">
                                <Users
                                    size={22}
                                />
                            </span>

                            <strong>
                                Staff
                            </strong>

                            <small>
                                Manage users
                            </small>
                        </button>

                    )}

                </div>


                {/* HISTORY */}

                {(isOwner ||
                    hasPermission(
                        "VIEW_PRICE_HISTORY"
                    )) && (

                    <>
                        <h3
                            className="section-title"
                            style={{
                                marginTop:
                                    "28px"
                            }}
                        >
                            Activity
                        </h3>


                        <button
                            className="action-card"
                            style={{
                                width:
                                    "100%",
                                minHeight:
                                    "100px"
                            }}
                            onClick={() =>
                                navigate(
                                    "/history"
                                )
                            }
                        >
                            <span className="action-icon">
                                <History
                                    size={22}
                                />
                            </span>

                            <strong>
                                History
                            </strong>

                            <small>
                                Price and import activity
                            </small>
                        </button>
                    </>

                )}

            </main>


            <nav className="bottom-nav">

                <button
                    className="nav-active"
                    onClick={() =>
                        navigate("/dashboard")
                    }
                >
                    <span>
                        <Home size={20} />
                    </span>

                    Home
                </button>


                <button
                    onClick={() =>
                        navigate("/products")
                    }
                >
                    <span>
                        <Boxes size={20} />
                    </span>

                    Products
                </button>


                {hasPermission(
                    "UPLOAD_EXCEL"
                ) ? (

                    <button
                        onClick={() =>
                            navigate("/import")
                        }
                    >
                        <span>
                            <Upload
                                size={20}
                            />
                        </span>

                        Import
                    </button>

                ) : hasPermission(
                    "EXPORT_FILES"
                ) ? (

                    <button
                        onClick={() =>
                            navigate("/export")
                        }
                    >
                        <span>
                            <Download
                                size={20}
                            />
                        </span>

                        Export
                    </button>

                ) : (

                    <button
                        onClick={() =>
                            navigate("/more")
                        }
                    >
                        <span>
                            <History
                                size={20}
                            />
                        </span>

                        Activity
                    </button>

                )}


                <button
                    onClick={() =>
                        navigate("/more")
                    }
                >
                    <span>
                        <MoreHorizontal
                            size={20}
                        />
                    </span>

                    More
                </button>

            </nav>

        </div>
    );
}


export default Dashboard;